import React, { memo, useState } from 'react';

import ErrorBoundary from '../ErrorBoundary';
import Header from '../Header';
import Sidebar from '../Sidebar';
import { Logger } from '../../../services/Logger';

import { useStyles } from './styles';
import GuestHeader from '../GuestHeader';
import CreditCardDeclinedModal from '../CreditCardDeclinedModal';
import moment from 'moment';
const packageJson = require('../../../../../package.json');

export interface IMainProps {
  children: React.ReactNode;
  isGuest: boolean;
  isFcaUser: boolean;
  failedTransactions: any;
}

const Main = ({ children, isGuest, isFcaUser, failedTransactions }: IMainProps) => {
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      {isGuest ? (
        <ErrorBoundary Logger={Logger}>
          <GuestHeader />
        </ErrorBoundary>
      ) : (
        <>
          <ErrorBoundary Logger={Logger}>
            <Header handleDrawerToggle={handleDrawerToggle} />
          </ErrorBoundary>
          <ErrorBoundary Logger={Logger}>
            <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
          </ErrorBoundary>
        </>
      )}
      <main
        key="Main"
        className={classes.appContainer}
        // Commenting the below code because drag and drop is not working inside the main.
        // onDragOver={/* istanbul ignore next line */ e => e.preventDefault()}
        // onDrop={
        //   /* istanbul ignore next line */ e => {
        //     e.stopPropagation();
        //     e.preventDefault();
        //     return false;
        //   }
        // }
      >
        {/* <div className={classes.headerSpacer} /> */}
        <section className={!isGuest ? `${classes.sectionContainer} ${classes.headerSpacer}` : classes.headerSpacer}>
          <ErrorBoundary Logger={Logger}>{children}</ErrorBoundary>
        </section>
        <footer className={classes.footer}>
          <p>
            Build version {packageJson.buildVersion} published on {packageJson.buildDate && moment(packageJson.buildDate).format('MMM DD, YYYY')}
          </p>
        </footer>
        {!isFcaUser && (
          <CreditCardDeclinedModal
            show={failedTransactions && failedTransactions.list && failedTransactions.list.length > 0 && !failedTransactions.isViewed}
            failedTransactions={failedTransactions}
          />
        )}
      </main>
    </>
  );
};

export default memo(Main);
